import React from 'react';
import PropTypes from 'prop-types';
import 'lazysizes';
import 'lazysizes/plugins/video-embed/ls.video-embed';

const PicturePlayer = (props) => {
  return <div className='embed-responsive embed-responsive-4by3 lazyload player'
              data-youtube={ props.code }
              data-thumb-size='default'>
    <a className={ 'player__link player__link_size_' + props.size }><i className='icon icon-youtube-play'></i></a>
  </div>
}

PicturePlayer.propTypes = {
  code: PropTypes.string.isRequired,
};

export default PicturePlayer;